// ============================================================================
// Shared Advisor AI progress-modal timer
// Ensures only one AI progress timer owns the modal at a time. This prevents
// stale timers from a previous Advisor tab continuing to update seconds/title.
// ============================================================================

import { updateProgressModal } from '@process-advisor/process-miner/api/methods/modals/updateProgressModal';

let activeTimer = null;
let activeSequence = 0;

const clearActiveTimer = () => {
  if (activeTimer?.intervalId) clearInterval(activeTimer.intervalId);
  activeTimer = null;
};

export const stopAllAiProgressTimers = () => {
  activeSequence += 1;
  clearActiveTimer();
};

export const startAiProgressTimer = async (label, options = {}) => {
  const intervalMs = options.intervalMs || 1000;
  stopAllAiProgressTimers();
  const sequence = activeSequence;
  let seconds = 0;

  await updateProgressModal({ status: `${label} — 0s`, ai: true });

  const intervalId = setInterval(() => {
    if (!activeTimer || activeTimer.sequence !== sequence) return;
    seconds += 1;
    updateProgressModal({ status: `${label} — ${seconds}s`, ai: true });
  }, intervalMs);

  activeTimer = { sequence, label, intervalId };
  return { sequence, label };
};

export const stopAiProgressTimer = (handle) => {
  if (!handle) return;
  if (activeTimer && activeTimer.sequence === handle.sequence) {
    clearActiveTimer();
  }
};
